import React from 'react';
import './App.css';
import './assets/main.css'
import { BrowserRouter as Router,Switch,Route } from "react-router-dom";
import PublicRoute from './Routes/PublicRoute';
import LoginScreen from './Screens/LoginScreen';
import SinglePageRoute from './Routes/SinglePageRoute';
import ProtectedUserRoute from './Routes/ProtectedUserRoute';
import PageNotFoundScreen from './Screens/PageNotFoundScreen';
import LogoutScreen from './Screens/LogoutScreen';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <SinglePageRoute exact path="/" component={LoginScreen} />
          <PublicRoute path="/logout" component={LogoutScreen} />
          <Route path="/user" render={ProtectedUserRoute} />
          <Route path="/admin" render={ProtectedUserRoute} />
          <Route path="" component={PageNotFoundScreen} />
        </Switch>
      </div>
    </Router>
  )
}


export default App;
